import IBaseListingResponse from "../../utils/api/base-listing-response";
import {DEFAULT_FUNCTION, DEFAULT_QUERY} from "../../utils/helpers/constants";
import {createContext} from "react";
import {ICategoryCampaign, ICategoryCampaignDetails} from "../../models/category_campaign/response";
import {ICategoryCampaignQuery} from "../../models/category_campaign/query";
import {ICreateCategoryCampaign, IUpdateCategoryCampaign} from "../../models/category_campaign/request";


export type CategoryCampaignLoading =
    | "list"
    | "details"
    | "create"
    | "update"
    | "delete";

export interface IInternalState {
  loading: CategoryCampaignLoading[];

  list?: IBaseListingResponse<ICategoryCampaign>;
  query: ICategoryCampaignQuery;

  details?: ICategoryCampaignDetails;
}

export const internalState: IInternalState = {
  loading: [],
  query: DEFAULT_QUERY,
};


export interface IExternalState extends IInternalState {
  actions: {
    getData: () => void;
    getDetails: (id: number) => void;
    setDetails: (data?: ICategoryCampaignDetails) => void;
    updateCategoriesArrangementList: (id: number, request: {
      "priority":number
    }) => void;
    createCategoryCampaign: (request: ICreateCategoryCampaign) => void;
    updateCategoryCampaign: (id: number, request: IUpdateCategoryCampaign) => void;
    deleteCategoryCampaign: (id: number) => void;
    exportExcel: (data: any) => any;

    setSearch: (search?: string) => void;
    setQuery: (query: ICategoryCampaignQuery) => void;
  };
}

export const externalState: IExternalState = {
  ...internalState,
  actions: {
    getData: DEFAULT_FUNCTION,
    getDetails: DEFAULT_FUNCTION,
    setDetails: DEFAULT_FUNCTION,
    exportExcel: DEFAULT_FUNCTION,

    createCategoryCampaign: DEFAULT_FUNCTION,
    updateCategoryCampaign: DEFAULT_FUNCTION,
    deleteCategoryCampaign: DEFAULT_FUNCTION,

    updateCategoriesArrangementList: DEFAULT_FUNCTION,

    setSearch: DEFAULT_FUNCTION,
    setQuery: DEFAULT_FUNCTION,

  },
};

const CategoryCampaignContext = createContext(externalState);

export default CategoryCampaignContext;